module.exports = __webpack_public_path__ + "img/int1_ent_cas_01.b58f7741.jpg";